var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchNameIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6952 17.6719L14.0702 14.0469M16.0286 9.33854C16.0286 13.0204 13.0439 16.0052 9.36198 16.0052C5.68008 16.0052 2.69531 13.0204 2.69531 9.33854C2.69531 5.65664 5.68008 2.67188 9.36198 2.67188C13.0439 2.67188 16.0286 5.65664 16.0286 9.33854Z",
    stroke: "#6F6F6F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchNameIcon);
export default __webpack_public_path__ + "static/media/SearchNameIcon.aa57aac062e6ee9a75a82a51a086f190.svg";
export { ForwardRef as ReactComponent };